var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g3, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g4, _path37, _g5, _path38, _g6, _path39, _g7, _path40, _g8, _path41, _g9, _path42, _g0, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsumerTrustNetworkLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 436,
    height: 55,
    viewBox: "0 0 436 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5318 0H0V55H55.5318V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31996_62564)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8426 50.7182C41.1654 50.7182 51.9656 39.8921 51.9656 26.5379C51.9656 13.1833 41.1654 2.35742 27.8426 2.35742C14.5199 2.35742 3.71973 13.1833 3.71973 26.5379C3.71973 39.8921 14.5199 50.7182 27.8426 50.7182Z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 55
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5318 0H0V55H55.5318V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31996_62564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 50,
    height: 50
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0168 2.27539H3.25977V51.145H52.0168V2.27539Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_31996_62564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 50,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6384 51.145C41.1021 51.145 52.0168 40.2051 52.0168 26.7102C52.0168 13.2154 41.1021 2.27539 27.6384 2.27539C14.1745 2.27539 3.25977 13.2154 3.25977 26.7102C3.25977 40.2051 14.1745 51.145 27.6384 51.145Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_31996_62564)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31996_62564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -2,
    width: 56,
    height: 57
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9885 26.4343C54.9885 11.203 42.6695 -1.14453 27.4733 -1.14453C12.277 -1.14453 -0.0419922 11.203 -0.0419922 26.4343C-0.0419922 41.6657 12.277 54.0132 27.4733 54.0132C42.6695 54.0132 54.9885 41.6657 54.9885 26.4343Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9885 26.4343C54.9885 11.203 42.6695 -1.14453 27.4733 -1.14453C12.277 -1.14453 -0.0419922 11.203 -0.0419922 26.4343C-0.0419922 41.6657 12.277 54.0132 27.4733 54.0132C42.6695 54.0132 54.9885 41.6657 54.9885 26.4343Z",
    fill: "url(#paint0_linear_31996_62564)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6378 50.5926C40.7977 50.5926 51.466 39.8997 51.466 26.7094C51.466 13.5192 40.7977 2.82617 27.6378 2.82617C14.4778 2.82617 3.80957 13.5192 3.80957 26.7094C3.80957 39.8997 14.4778 50.5926 27.6378 50.5926Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.6379 51.0894C41.0715 51.0894 51.9615 40.1742 51.9615 26.7098C51.9615 13.2452 41.0715 2.33008 27.6379 2.33008C14.2044 2.33008 3.31445 13.2452 3.31445 26.7098C3.31445 40.1742 14.2044 51.0894 27.6379 51.0894Z",
    stroke: "#EDEDED",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7969 23.0703H84.8151",
    stroke: "black",
    strokeWidth: 0.4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9331 26.4338C54.9331 11.233 42.6387 -1.08984 27.4728 -1.08984C12.3071 -1.08984 0.0126953 11.233 0.0126953 26.4338C0.0126953 41.6348 12.3071 53.9575 27.4728 53.9575C42.6387 53.9575 54.9331 41.6348 54.9331 26.4338Z",
    stroke: "#A7A8AC",
    strokeWidth: 0.4
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 9.1543L34.4635 9.15451",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6353 14.3613L11.1074 29.2403",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1504 12.8691L43.86 27.7037",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1348 33.6016L27.2016 30.8516",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1055 31.8887L31.3984 36.8521",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6611 29.75L22.8366 36.3231",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5469 24.261L36.5541 12.9258",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 14.0664L22.5802 20.4383",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5332 21.0957L21.1582 23.7787",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6426 28.4046L21.5427 26.9961",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4122 28.6045L33.252 27.1289",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0716 20.9629L33.6475 23.5787",
    stroke: "#9D9D9D",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 24,
    width: 9,
    height: 10
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.588 28.841C14.588 26.5071 12.7005 24.6152 10.3721 24.6152C8.04375 24.6152 6.15625 26.5071 6.15625 28.841C6.15625 31.1747 8.04375 33.0665 10.3721 33.0665C12.7005 33.0665 14.588 31.1747 14.588 28.841Z",
    fill: "#FFE490"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.588 28.841C14.588 26.5071 12.7005 24.6152 10.3721 24.6152C8.04375 24.6152 6.15625 26.5071 6.15625 28.841C6.15625 31.1747 8.04375 33.0665 10.3721 33.0665C12.7005 33.0665 14.588 31.1747 14.588 28.841Z",
    fill: "#DCC0CC"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5174 37.7533C31.5174 35.3158 29.5461 33.3398 27.1142 33.3398C24.6824 33.3398 22.7109 35.3158 22.7109 37.7533C22.7109 40.1908 24.6824 42.1668 27.1142 42.1668C29.5461 42.1668 31.5174 40.1908 31.5174 37.7533Z",
    fill: "#C4C4C4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9129 28.9262C47.9129 26.8518 46.2352 25.1699 44.1655 25.1699C42.0957 25.1699 40.418 26.8518 40.418 28.9262C40.418 31.0006 42.0957 32.6822 44.1655 32.6822C46.2352 32.6822 47.9129 31.0006 47.9129 28.9262Z",
    fill: "#C4C4C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0087 11.1324C20.0087 9.09498 18.3607 7.44336 16.3281 7.44336C14.2953 7.44336 12.6475 9.09498 12.6475 11.1324C12.6475 13.1698 14.2953 14.8214 16.3281 14.8214C18.3607 14.8214 20.0087 13.1698 20.0087 11.1324Z",
    fill: "#C4C4C4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4899 10.3953C41.4899 8.39503 39.872 6.77344 37.8762 6.77344C35.8805 6.77344 34.2627 8.39503 34.2627 10.3953C34.2627 12.3958 35.8805 14.0173 37.8762 14.0173C39.872 14.0173 41.4899 12.3958 41.4899 10.3953Z",
    fill: "#C4C4C4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7913 20.3799C43.7913 19.3427 42.9525 18.502 41.9176 18.502C40.8829 18.502 40.0439 19.3427 40.0439 20.3799C40.0439 21.4172 40.8829 22.2581 41.9176 22.2581C42.9525 22.2581 43.7913 21.4172 43.7913 20.3799Z",
    fill: "#C4C4C4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9359 20.005C14.9359 18.9678 14.097 18.127 13.0623 18.127C12.0274 18.127 11.1885 18.9678 11.1885 20.005C11.1885 21.0423 12.0274 21.8831 13.0623 21.8831C14.097 21.8831 14.9359 21.0423 14.9359 20.005Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 17,
    height: 17
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4616 16.7188H19.5264V32.6909H35.4616V16.7188Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_31996_62564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 17,
    height: 17
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4939 32.6909C31.8944 32.6909 35.4616 29.1152 35.4616 24.7049C35.4616 20.2941 31.8944 16.7188 27.4939 16.7188C23.0935 16.7188 19.5264 20.2941 19.5264 24.7049C19.5264 29.1152 23.0935 32.6909 27.4939 32.6909Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_31996_62564)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 18,
    width: 13,
    height: 13
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8594 24.6061C33.8594 21.0795 30.9861 18.2207 27.4419 18.2207C23.8976 18.2207 21.0244 21.0795 21.0244 24.6061C21.0244 28.1325 23.8976 30.9913 27.4419 30.9913C30.9861 30.9913 33.8594 28.1325 33.8594 24.6061Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_31996_62564)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4886 31.3673C31.1623 31.3673 34.1403 28.3823 34.1403 24.7003C34.1403 21.0181 31.1623 18.0332 27.4886 18.0332C23.815 18.0332 20.8369 21.0181 20.8369 24.7003C20.8369 28.3823 23.815 31.3673 27.4886 31.3673Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.475 31.1523C31.0895 31.1523 34.0196 28.2155 34.0196 24.5927C34.0196 20.9699 31.0895 18.0332 27.475 18.0332C23.8607 18.0332 20.9307 20.9699 20.9307 24.5927C20.9307 28.2155 23.8607 31.1523 27.475 31.1523Z",
    fill: "#C3C3C3"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4154 24.6147C36.4154 19.6466 32.3972 15.6191 27.4406 15.6191C22.484 15.6191 18.4658 19.6466 18.4658 24.6147C18.4658 29.5828 22.484 33.6103 27.4406 33.6103C32.3972 33.6103 36.4154 29.5828 36.4154 24.6147Z",
    stroke: "#A7A8AC",
    strokeWidth: 0.4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4296 24.7214L29.474 24.252C29.4361 24.2337 29.392 24.2337 29.3541 24.252L28.3984 24.7214C28.3518 24.7445 28.3223 24.7921 28.3223 24.8443V26.0961C28.3223 26.1487 28.3518 26.196 28.3988 26.2192L29.3541 26.6885C29.373 26.6978 29.3937 26.7025 29.414 26.7025C29.4348 26.7025 29.455 26.6978 29.474 26.6885L30.4296 26.2189C30.4765 26.196 30.5063 26.1483 30.5063 26.0961V24.8443C30.5063 24.7921 30.4765 24.7445 30.4296 24.7214Z",
    fill: "#A7A7A7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3349 24.7214L25.3794 24.252C25.3413 24.2337 25.2972 24.2337 25.2593 24.252L24.3037 24.7214C24.2571 24.7445 24.2275 24.7921 24.2275 24.8443V26.0961C24.2275 26.1487 24.2571 26.196 24.304 26.2192L25.2593 26.6885C25.2783 26.6978 25.2989 26.7025 25.3192 26.7025C25.34 26.7025 25.3603 26.6978 25.3794 26.6885L26.3349 26.2189C26.3818 26.196 26.4114 26.1483 26.4114 26.0961V24.8443C26.4114 24.7921 26.3818 24.7445 26.3349 24.7214Z",
    fill: "#A7A7A7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3827 21.8486L27.4271 21.3793C27.3896 21.3606 27.3451 21.3606 27.3075 21.3793L26.3519 21.8486C26.3048 21.8715 26.2754 21.9195 26.2754 21.9716V23.2234C26.2754 23.2757 26.3048 23.3233 26.3519 23.3463L27.3075 23.8159C27.3264 23.8251 27.3468 23.8298 27.3674 23.8298C27.3878 23.8298 27.4085 23.8251 27.4271 23.8155L28.3827 23.3463C28.4296 23.3233 28.4593 23.2757 28.4593 23.2231V21.9716C28.4593 21.9195 28.4296 21.8715 28.3827 21.8486Z",
    fill: "#A7A7A7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.322 24.3724C25.2465 24.3724 25.1855 24.3112 25.1855 24.2355V23.14C25.1855 23.0871 25.2158 23.0391 25.2633 23.0165L26.2185 22.56C26.2868 22.5278 26.3682 22.5569 26.4007 22.6251C26.433 22.6931 26.4042 22.7747 26.3358 22.8077L25.4585 23.2266V24.2355C25.4585 24.3112 25.3976 24.3724 25.322 24.3724Z",
    fill: "#24272A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4147 24.3724C29.3389 24.3724 29.278 24.3112 29.278 24.2355V23.2269L28.4004 22.8077C28.332 22.7747 28.3031 22.6931 28.3356 22.6251C28.368 22.5569 28.449 22.5278 28.5176 22.56L29.4729 23.0165C29.5208 23.0394 29.5508 23.0875 29.5508 23.1404V24.2355C29.5508 24.3112 29.4901 24.3724 29.4147 24.3724Z",
    fill: "#24272A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3658 27.1145C27.3452 27.1145 27.3244 27.1101 27.3056 27.1005L25.9392 26.4218C25.8716 26.3882 25.8441 26.3058 25.8775 26.2385C25.911 26.1706 25.9927 26.143 26.0602 26.1761L27.3658 26.825L28.6714 26.1765C28.739 26.143 28.821 26.1706 28.8541 26.2385C28.8876 26.3062 28.86 26.3887 28.7924 26.4222L27.4264 27.1005C27.4076 27.1101 27.3865 27.1145 27.3658 27.1145Z",
    fill: "#24272A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12695 30.8039L9.50166 30.0527L21.9619 34.3723L24.0698 35.3112L23.0862 37.6588L9.12695 30.8039Z",
    fill: "#A7A7A7"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 9,
    height: 9
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1424 11.2021C20.1424 9.09057 18.4346 7.37891 16.328 7.37891C14.2214 7.37891 12.5137 9.09057 12.5137 11.2021C12.5137 13.3135 14.2214 15.0253 16.328 15.0253C18.4346 15.0253 20.1424 13.3135 20.1424 11.2021Z",
    fill: "#FFE490"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1424 11.2021C20.1424 9.09057 18.4346 7.37891 16.328 7.37891C14.2214 7.37891 12.5137 9.09057 12.5137 11.2021C12.5137 13.3135 14.2214 15.0253 16.328 15.0253C18.4346 15.0253 20.1424 13.3135 20.1424 11.2021Z",
    fill: "#FAD181"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 6,
    width: 8,
    height: 9
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6233 10.4967C41.6233 8.40375 39.9305 6.70703 37.8424 6.70703C35.7542 6.70703 34.0615 8.40375 34.0615 10.4967C34.0615 12.5896 35.7542 14.2863 37.8424 14.2863C39.9305 14.2863 41.6233 12.5896 41.6233 10.4967Z",
    fill: "#FFE490"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6233 10.4967C41.6233 8.40375 39.9305 6.70703 37.8424 6.70703C35.7542 6.70703 34.0615 8.40375 34.0615 10.4967C34.0615 12.5896 35.7542 14.2863 37.8424 14.2863C39.9305 14.2863 41.6233 12.5896 41.6233 10.4967Z",
    fill: "#8EB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 17,
    width: 6,
    height: 6
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3671 20.1888C44.3671 18.818 43.2585 17.707 41.891 17.707C40.5236 17.707 39.415 18.818 39.415 20.1888C39.415 21.5594 40.5236 22.6705 41.891 22.6705C43.2585 22.6705 44.3671 21.5594 44.3671 20.1888Z",
    fill: "#FFE490"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3671 20.1888C44.3671 18.818 43.2585 17.707 41.891 17.707C40.5236 17.707 39.415 18.818 39.415 20.1888C39.415 21.5594 40.5236 22.6705 41.891 22.6705C43.2585 22.6705 44.3671 21.5594 44.3671 20.1888Z",
    fill: "#C7998B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 24,
    width: 10,
    height: 10
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2484 29.2432C48.2484 26.7984 46.271 24.8164 43.8316 24.8164C41.3925 24.8164 39.415 26.7984 39.415 29.2432C39.415 31.6881 41.3925 33.6701 43.8316 33.6701C46.271 33.6701 48.2484 31.6881 48.2484 29.2432Z",
    fill: "#FFE490"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2484 29.2432C48.2484 26.7984 46.271 24.8164 43.8316 24.8164C41.3925 24.8164 39.415 26.7984 39.415 29.2432C39.415 31.6881 41.3925 33.6701 43.8316 33.6701C46.271 33.6701 48.2484 31.6881 48.2484 29.2432Z",
    fill: "#74A99C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 32,
    width: 10,
    height: 11
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6527 37.4933C31.6527 34.8261 29.6154 32.6641 27.1023 32.6641C24.5891 32.6641 22.5518 34.8261 22.5518 37.4933C22.5518 40.1604 24.5891 42.3225 27.1023 42.3225C29.6154 42.3225 31.6527 40.1604 31.6527 37.4933Z",
    fill: "#FFE490"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6527 37.4933C31.6527 34.8261 29.6154 32.6641 27.1023 32.6641C24.5891 32.6641 22.5518 34.8261 22.5518 37.4933C22.5518 40.1604 24.5891 42.3225 27.1023 42.3225C29.6154 42.3225 31.6527 40.1604 31.6527 37.4933Z",
    fill: "#DC977A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_31996_62564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 17,
    width: 6,
    height: 6
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3912 20.1217C15.3912 18.8992 14.4025 17.9082 13.183 17.9082C11.9634 17.9082 10.9746 18.8992 10.9746 20.1217C10.9746 21.3441 11.9634 22.3351 13.183 22.3351C14.4025 22.3351 15.3912 21.3441 15.3912 20.1217Z",
    fill: "#FFE490"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3912 20.1217C15.3912 18.8992 14.4025 17.9082 13.183 17.9082C11.9634 17.9082 10.9746 18.8992 10.9746 20.1217C10.9746 21.3441 11.9634 22.3351 13.183 22.3351C14.4025 22.3351 15.3912 21.3441 15.3912 20.1217Z",
    fill: "#8884E2"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_31996_62564",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 3,
    width: 60,
    height: 15
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.491 3.66602H61.1113V17.1105H120.491V3.66602Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_31996_62564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.261 13.7486V7.40167H76.9814V5.98438H83.0198V7.40167H80.7402V13.7486H79.261ZM82.9273 13.7486V8.07947H83.9749L84.2214 8.69566C84.3197 8.57246 84.4427 8.46149 84.5786 8.36294C84.8128 8.17808 85.1454 8.01787 85.5763 8.01787C85.7122 8.01787 85.7983 8.04252 85.885 8.05481L86.0079 8.07947V9.55839L85.8727 9.53373C85.786 9.52137 85.663 9.49672 85.5149 9.49672C84.8251 9.49672 84.3443 9.98972 84.3443 10.7291V13.7486H82.9273ZM86.5987 11.407V8.07947H88.0157V11.2221C88.0157 11.9616 88.4965 12.4545 89.1869 12.4545C89.8767 12.4545 90.3574 11.9616 90.3574 11.2221V8.07947H91.7745V13.7486H90.7269L90.4804 13.194C90.3451 13.3049 90.1847 13.4158 90.0249 13.5021C89.7414 13.6623 89.3344 13.8102 88.8789 13.8102C87.535 13.8102 86.5987 12.8858 86.5987 11.407ZM96.9879 13.7486L96.7413 13.194C96.6054 13.3049 96.4702 13.4158 96.3097 13.5021C96.0263 13.6623 95.6323 13.8102 95.1392 13.8102C93.7222 13.8102 92.4895 12.5901 92.4895 10.914C92.4895 9.23796 93.7222 8.01787 95.1392 8.01787C95.5954 8.01787 95.9649 8.16572 96.2237 8.30128C96.3719 8.3876 96.5071 8.47385 96.6184 8.57246V5.98438H98.0354V13.7486H96.9879ZM95.3243 12.4545C96.1253 12.4545 96.7413 11.8507 96.7413 10.914C96.7413 9.97736 96.1253 9.37352 95.3243 9.37352C94.5232 9.37352 93.9066 9.97736 93.9066 10.914C93.9066 11.8507 94.5232 12.4545 95.3243 12.4545ZM102.631 12.0232H104.109C103.814 12.8735 102.865 13.8102 101.583 13.8102C100.055 13.8102 98.7485 12.5161 98.7485 10.914C98.7485 9.31186 100.055 8.01787 101.583 8.01787C103.062 8.01787 104.294 9.18866 104.294 10.914C104.294 11.0496 104.27 11.1728 104.258 11.2837L104.233 11.4686H100.289C100.425 12.0232 100.844 12.4545 101.583 12.4545C101.965 12.4545 102.199 12.3559 102.384 12.245C102.483 12.1834 102.569 12.1094 102.631 12.0232ZM100.228 10.4826H102.939C102.804 9.85416 102.323 9.37352 101.583 9.37352C100.844 9.37352 100.363 9.85416 100.228 10.4826ZM105.003 13.7486V8.07947H106.051L106.297 8.63406C106.433 8.52316 106.593 8.41225 106.753 8.32593C107.037 8.17808 107.418 8.01787 107.899 8.01787C109.243 8.01787 110.179 8.94213 110.179 10.421V13.7486H108.762V10.6059C108.762 9.86645 108.282 9.37352 107.591 9.37352C106.901 9.37352 106.421 9.86645 106.421 10.6059V13.7486H105.003ZM111.573 11.7767V9.37352H110.711V8.20273H111.08C111.536 8.20273 111.758 7.98086 111.758 7.52487V6.72382H112.991V8.07947H114.223V9.37352H112.991V11.7151C112.991 12.208 113.299 12.5161 113.791 12.5161C113.927 12.5161 114.001 12.5037 114.062 12.4916L114.161 12.4545V13.6869C114.1 13.7115 114.038 13.7363 113.964 13.7486C113.829 13.7855 113.668 13.8102 113.483 13.8102C112.362 13.8102 111.573 13.0092 111.573 11.7767ZM115.362 15.7204V14.5497C115.991 14.5497 116.286 14.2415 116.471 13.8102L116.595 13.5021L114.438 8.07947H115.917L117.334 11.7767L118.628 8.07947H120.107L119.011 10.8894C118.456 12.3189 117.901 13.7979 117.827 13.9334C117.272 15.2768 116.779 15.782 115.855 15.782C115.72 15.782 115.597 15.7696 115.511 15.7573L115.362 15.7204Z",
    fill: "#424446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1949 4.22656H62.7919C61.8637 4.22656 61.1113 4.97896 61.1113 5.90712V14.3099C61.1113 15.2381 61.8637 15.9905 62.7919 15.9905H71.1949C72.1228 15.9905 72.8753 15.2381 72.8753 14.3099V5.90712C72.8753 4.97896 72.1228 4.22656 71.1949 4.22656Z",
    fill: "#424446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.732 6.32812H64.0518V7.58857H65.732V6.32812Z",
    fill: "#BABCBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4138 6.32812H66.1533V7.58857V13.8905H67.4138V7.58857H69.9347V6.32812H67.4138Z",
    fill: "white"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2613 37.1561H83.8444C82.7813 41.5561 78.8575 45.4061 73.3944 45.4061C67.3444 45.4061 62.2109 40.2728 62.2109 33.6728C62.2109 27.0728 67.3444 21.9395 73.3944 21.9395C78.6744 21.9395 82.5975 25.7895 83.6613 30.1895H79.0775C78.4913 28.1728 76.5113 26.1561 73.3944 26.1561C69.7275 26.1561 66.6113 29.2728 66.6113 33.6728C66.6113 38.0728 69.7275 41.1895 73.3944 41.1895C76.5475 41.1895 78.4913 39.1728 79.2613 37.1561ZM94.1546 32.2061C91.7715 32.2061 89.9384 34.0028 89.9384 36.7895C89.9384 39.5761 91.7715 41.3728 94.1546 41.3728C96.5384 41.3728 98.3715 39.5761 98.3715 36.7895C98.3715 34.0028 96.5384 32.2061 94.1546 32.2061ZM94.1546 28.1728C98.7015 28.1728 102.588 32.0228 102.588 36.7895C102.588 41.5561 98.7015 45.4061 94.1546 45.4061C89.6084 45.4061 85.7215 41.5561 85.7215 36.7895C85.7215 32.0228 89.6084 28.1728 94.1546 28.1728ZM105.566 45.2228V28.3561H108.682L109.416 30.0061C109.819 29.6761 110.296 29.3461 110.772 29.0895C111.616 28.6495 112.752 28.1728 114.182 28.1728C118.179 28.1728 120.966 30.9228 120.966 35.3228V45.2228H116.749V35.8728C116.749 33.6728 115.319 32.2061 113.265 32.2061C111.212 32.2061 109.782 33.6728 109.782 35.8728V45.2228H105.566ZM123.791 39.9061H127.825C128.008 41.0428 128.925 41.9228 130.391 41.9228C131.858 41.9228 132.775 41.0061 132.775 40.0895C132.775 37.7061 124.158 39.1361 124.158 33.3061C124.158 30.5561 126.541 28.1728 130.208 28.1728C134.278 28.1728 136.405 30.3728 136.808 33.3061H132.775C132.591 32.5728 131.675 31.6561 130.391 31.6561C129.108 31.6561 128.375 32.3895 128.375 33.3061C128.375 35.6528 136.991 34.2595 136.991 40.2728C136.991 43.0228 134.571 45.4061 130.758 45.4061C126.358 45.4061 124.121 43.2428 123.791 39.9061ZM139.982 38.2561V28.3561H144.199V37.7061C144.199 39.9061 145.629 41.3728 147.682 41.3728C149.736 41.3728 151.166 39.9061 151.166 37.7061V28.3561H155.382V45.2228H152.266L151.532 43.5728C151.129 43.9028 150.652 44.2328 150.176 44.4895C149.332 44.9661 148.122 45.4061 146.766 45.4061C142.769 45.4061 139.982 42.6561 139.982 38.2561ZM159.303 45.2228V28.3561H162.42L163.153 30.0061C163.483 29.6761 163.886 29.3461 164.29 29.0895C164.986 28.6495 165.976 28.1728 167.186 28.1728C168.91 28.1728 170.12 28.7228 170.89 29.2728C171.33 29.6028 171.696 29.9695 171.953 30.3728C172.356 29.9695 172.796 29.6028 173.31 29.2728C174.19 28.7228 175.436 28.1728 176.903 28.1728C180.57 28.1728 182.953 30.5561 182.953 35.1395V45.2228H178.736V35.5061C178.736 33.4528 177.453 32.2061 175.986 32.2061C174.52 32.2061 173.236 33.4528 173.236 35.5061V45.2228H169.02V35.5061C169.02 33.4528 167.736 32.2061 166.27 32.2061C164.803 32.2061 163.52 33.4528 163.52 35.5061V45.2228H159.303ZM197.314 40.0895H201.714C200.834 42.6195 198.011 45.4061 194.198 45.4061C189.651 45.4061 185.764 41.5561 185.764 36.7895C185.764 32.0228 189.651 28.1728 194.198 28.1728C198.598 28.1728 202.264 31.6561 202.264 36.7895C202.264 37.1928 202.191 37.5595 202.154 37.8895L202.081 38.4395H190.348C190.751 40.0895 191.998 41.3728 194.198 41.3728C195.334 41.3728 196.031 41.0795 196.581 40.7495C196.874 40.5661 197.131 40.3461 197.314 40.0895ZM190.164 35.5061H198.231C197.828 33.6361 196.398 32.2061 194.198 32.2061C191.998 32.2061 190.568 33.6361 190.164 35.5061ZM205.25 45.2228V28.3561H208.367L209.1 30.1895C209.393 29.8228 209.76 29.4928 210.163 29.1995C210.86 28.6495 211.85 28.1728 213.133 28.1728C213.537 28.1728 213.793 28.2461 214.05 28.2828L214.417 28.3561V32.7561L214.013 32.6828C213.757 32.6461 213.39 32.5728 212.95 32.5728C210.897 32.5728 209.467 34.0395 209.467 36.2395V45.2228H205.25ZM230.483 45.2228V26.3395H223.7V22.1228H241.666V26.3395H234.883V45.2228H230.483ZM242.266 45.2228V28.3561H245.383L246.116 30.1895C246.41 29.8228 246.776 29.4928 247.18 29.1995C247.876 28.6495 248.866 28.1728 250.15 28.1728C250.553 28.1728 250.81 28.2461 251.066 28.2828L251.433 28.3561V32.7561L251.03 32.6828C250.773 32.6461 250.406 32.5728 249.966 32.5728C247.913 32.5728 246.483 34.0395 246.483 36.2395V45.2228H242.266ZM254.068 38.2561V28.3561H258.285V37.7061C258.285 39.9061 259.715 41.3728 261.768 41.3728C263.821 41.3728 265.251 39.9061 265.251 37.7061V28.3561H269.468V45.2228H266.351L265.618 43.5728C265.215 43.9028 264.738 44.2328 264.261 44.4895C263.418 44.9661 262.208 45.4061 260.851 45.4061C256.855 45.4061 254.068 42.6561 254.068 38.2561ZM272.472 39.9061H276.506C276.689 41.0428 277.606 41.9228 279.072 41.9228C280.539 41.9228 281.456 41.0061 281.456 40.0895C281.456 37.7061 272.839 39.1361 272.839 33.3061C272.839 30.5561 275.222 28.1728 278.889 28.1728C282.959 28.1728 285.086 30.3728 285.489 33.3061H281.456C281.272 32.5728 280.356 31.6561 279.072 31.6561C277.789 31.6561 277.056 32.3895 277.056 33.3061C277.056 35.6528 285.672 34.2595 285.672 40.2728C285.672 43.0228 283.252 45.4061 279.439 45.4061C275.039 45.4061 272.802 43.2428 272.472 39.9061ZM289.948 39.3561V32.2061H287.381V28.7228H288.481C289.838 28.7228 290.498 28.0628 290.498 26.7061V24.3228H294.164V28.3561H297.831V32.2061H294.164V39.1728C294.164 40.6395 295.081 41.5561 296.548 41.5561C296.951 41.5561 297.171 41.5195 297.354 41.4828L297.648 41.3728V45.0395C297.464 45.1128 297.281 45.1861 297.061 45.2228C296.658 45.3328 296.181 45.4061 295.631 45.4061C292.294 45.4061 289.948 43.0228 289.948 39.3561ZM309.662 45.2228V22.1228H313.512L323.779 37.1561V22.1228H328.179V45.2228H324.329L314.062 30.1895V45.2228H309.662ZM343.081 40.0895H347.481C346.601 42.6195 343.778 45.4061 339.965 45.4061C335.418 45.4061 331.531 41.5561 331.531 36.7895C331.531 32.0228 335.418 28.1728 339.965 28.1728C344.365 28.1728 348.031 31.6561 348.031 36.7895C348.031 37.1928 347.958 37.5595 347.921 37.8895L347.848 38.4395H336.115C336.518 40.0895 337.765 41.3728 339.965 41.3728C341.101 41.3728 341.798 41.0795 342.348 40.7495C342.641 40.5661 342.898 40.3461 343.081 40.0895ZM335.931 35.5061H343.998C343.595 33.6361 342.165 32.2061 339.965 32.2061C337.765 32.2061 336.335 33.6361 335.931 35.5061ZM352.301 39.3561V32.2061H349.734V28.7228H350.834C352.191 28.7228 352.851 28.0628 352.851 26.7061V24.3228H356.517V28.3561H360.184V32.2061H356.517V39.1728C356.517 40.6395 357.434 41.5561 358.901 41.5561C359.304 41.5561 359.524 41.5195 359.707 41.4828L360.001 41.3728V45.0395C359.817 45.1128 359.634 45.1861 359.414 45.2228C359.011 45.3328 358.534 45.4061 357.984 45.4061C354.647 45.4061 352.301 43.0228 352.301 39.3561ZM367.202 45.2228L361.702 28.3561H365.919L369.219 39.1728L372.702 28.3561H375.269L378.752 39.1728L382.052 28.3561H386.269L380.769 45.2228H377.102L373.985 35.1395L370.869 45.2228H367.202ZM395.852 32.2061C393.469 32.2061 391.635 34.0028 391.635 36.7895C391.635 39.5761 393.469 41.3728 395.852 41.3728C398.235 41.3728 400.069 39.5761 400.069 36.7895C400.069 34.0028 398.235 32.2061 395.852 32.2061ZM395.852 28.1728C400.399 28.1728 404.285 32.0228 404.285 36.7895C404.285 41.5561 400.399 45.4061 395.852 45.4061C391.305 45.4061 387.419 41.5561 387.419 36.7895C387.419 32.0228 391.305 28.1728 395.852 28.1728ZM407.261 45.2228V28.3561H410.378L411.111 30.1895C411.405 29.8228 411.771 29.4928 412.175 29.1995C412.871 28.6495 413.861 28.1728 415.145 28.1728C415.548 28.1728 415.805 28.2461 416.061 28.2828L416.428 28.3561V32.7561L416.025 32.6828C415.768 32.6461 415.401 32.5728 414.961 32.5728C412.908 32.5728 411.478 34.0395 411.478 36.2395V45.2228H407.261ZM419.063 45.2228V22.1228H423.28V35.3228L428.413 28.3561H433.18L427.13 36.4228L433.913 45.2228H429.147L423.28 37.5228V45.2228H419.063Z",
    fill: "#424446"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31996_62564",
    x: -4.1875,
    y: -1.28906,
    width: 63.3203,
    height: 63.4473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31996_62564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31996_62564",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31996_62564",
    x: -130.19,
    y: -131.174,
    width: 315.656,
    height: 315.766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67,
    result: "effect1_foregroundBlur_31996_62564"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31996_62564",
    x: -113.163,
    y: -115.967,
    width: 281.304,
    height: 281.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67,
    result: "effect1_foregroundBlur_31996_62564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31996_62564",
    x1: 27.4733,
    y1: -1.14453,
    x2: 33.1121,
    y2: 57.8717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerTrustNetworkLogo);
export default __webpack_public_path__ + "static/media/consumer_trust_network_logo.54e47319aba8a4563bf138b0b914ffa9.svg";
export { ForwardRef as ReactComponent };